module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"matching":"Matching","cod":"COD"},"id":{"matching":"Matching","cod":"COD"}}')
  delete Component.options._Ctor
}
